module.exports = __webpack_public_path__ + "img/slider-img.47a41228.png";